import moment from '@/moment-gp'

export default {
  create({ timeslotCollectionId, tscType, exceptionType }) {

    function toTS(date) {
      return moment( date ) // append Z?
    }

    if (exceptionType === 'INS') {
      switch ( tscType ) {
        case 'TSC':
        case 'COMMITMENT':
        return {
          tscId:   timeslotCollectionId,
          type:    'INS', // Enum (String) [DEL, INS, CHG]
          from:    toTS('2018-10-13T00:00:00-04:00'), // [Datetime ISO 8601]
          to:      toTS('2018-10-13T00:00:00-04:00'), // [Datetime ISO 8601]
          all_day: false, // * [Boolean]
        }

        case 'BLOCKER':
        return {
          tscId:   timeslotCollectionId,
          type:    'INS', // Enum (String) [DEL, INS, CHG]
          from:    toTS('2018-10-13T00:00:00-04:00'), // [Datetime ISO 8601]
          to:      toTS('2018-10-13T00:00:00-04:00'), // [Datetime ISO 8601]
          all_day: false, // * [Boolean]
        }

        case 'GOOGLE':
        return {
          tscId:   timeslotCollectionId,
          type:    'INS', // Enum (String) [DEL, INS, CHG]
          from:    toTS('2018-10-13T00:00:00-04:00'), // [Datetime ISO 8601]
          to:      toTS('2018-10-13T00:00:00-04:00'), // [Datetime ISO 8601]
          all_day: false, // * [Boolean]
          ref:     '<googleRefUUID>', // * [String]
        }
      }
    }

    if (exceptionType === 'DEL') {
      if ( tscType === 'TSC' ||
           tscType === 'COMMITMENT' ) {
        return {
          tscId: timeslotCollectionId,
          type:  'DEL', // Enum (String) [DEL, INS, CHG]
          ref:   '<WeekdayPrefUUID>', // Reference
          date:  toTS('2018-10-13T00:00:00-04:00'), // [Date ISO 8601]
        };
      }
    }

    if (exceptionType === 'CHG') {
      if ( tscType === 'TSC' ||
           tscType === 'COMMITMENT' ) {
        return {
          tscId:    timeslotCollectionId,
          type:     'CHG', // Enum (String) [DEL, INS, CHG]
          ref:      '<WeekdayPrefUUID>', // Reference
          date:     toTS('2018-10-13T00:00:00-04:00'), // [Date ISO 8601]
          new_from: '15:00', // [Time ISO 8601]
          new_to:   '18:00', // [Time ISO 8601] or <null>
        };
      }
    }

    return false;
  },

  fields: {
    tscId: { validate_bolt_type: 'PushID' },
    type: { validate_bolt_type: 'String' },
    all_day: { validate_bolt_type: 'Boolean' },
    ref: { validate_bolt_type: 'String' },
    date: { validate_bolt_type: 'Timestamp' },
    to: { validate_bolt_type: 'Timestamp' },
    from: { validate_bolt_type: 'Timestamp' },
    new_from: { validate_bolt_type: 'String' },
    new_to: { validate_bolt_type: 'String' },
  }
}
